import Header from "./common/Header.js";
import Footer from "./common/Footer.js";
import Checkbox from "./common/Checkbox";
import SelectChecked from "./images/SelectChecked.svg";
import SelectUnchecked from "./images/SelectUnchecked.svg";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";

export default function SignupCallWizardEnrollment(props) {
  if (props.state.wizardStep !== "signup") {
    return null;
  }
  var steps = ["Sign Up", "Talk to our team"];
  var activeStep = 0;
  return (
    <div className="App" style={{ backgroundColor: props.state.wizardStep === "thank-you" ? "#4f196f" : "#f3f3f3" }}>
      <Header />
      <div>
        <div className="section center small apply" style={{ paddingTop: "36px", height: "250px" }}>
          <div>
            <h1 style={{ marginTop: 0, marginBottom: "20px" }} className="paragraph purple apply">
              Sign up to match with your Duo
            </h1>
          </div>
          <Stepper activeStep={activeStep} alternativeLabel style={{ backgroundColor: "transparent" }}>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel style={{ color: "green !important" }}>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </div>

        <div>
          <form id="enrollment-form" onSubmit={props.handleEnrollment}>
            <SectionTasks
              state={props.state}
              handleChange={props.handleChange}
              handleTaskSelection={props.handleTaskSelection}
              errorHandler={props.errorHandler}
            />
            <SectionPersonal state={props.state} handleChange={props.handleChange} errorHandler={props.errorHandler} />
            <SectionInvite state={props.state} handleChange={props.handleChange} errorHandler={props.errorHandler} />

            <div className="memberpod privacy" style={{ paddingBottom: "0px" }}>
              <div className="w-container">
                <div style={{ marginBottom: "25px", display: "table-row" }}>
                  <div style={{ display: "table-cell", verticalAlign: "middle" }}>
                    <label style={Object.assign({ margin: "0" }, props.errorHandler("termsAndPrivacyAccepted"))}>
                      <Checkbox checked={props.state.termsAndPrivacyAccepted} onChange={props.handleCheckboxChange} />
                    </label>
                  </div>
                  <div style={{ display: "table-cell", verticalAlign: "middle", paddingLeft: "15px" }}>
                    <label>
                      <span style={{ fontSize: "22px" }}>
                        I have read the{" "}
                        <a
                          href="https://getduos.com/terms-of-service"
                          target="_blank"
                          rel="noreferrer"
                          style={{ color: "#172e7d", textDecoration: "none" }}
                        >
                          terms of service
                        </a>{" "}
                        and{" "}
                        <a
                          href="https://getduos.com/privacy-policy"
                          target="_blank"
                          rel="noreferrer"
                          style={{ color: "#172e7d", textDecoration: "none" }}
                        >
                          privacy policy
                        </a>
                        .
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="memberpod privacy">
              <div className="w-container">
                <div style={{ marginBottom: "35px" }}>
                  <button
                    type="submit"
                    className="button-hero sub purple w-button"
                    style={{ width: "100%" }}
                    disabled={props.state.isEnrollmentSubmitting}
                  >
                    <span style={{ display: props.state.isEnrollmentSubmitting ? "none" : "block" }}>
                      Talk to our team
                    </span>
                    <svg
                      style={{ display: props.state.isEnrollmentSubmitting ? "block" : "none" }}
                      className="spinner"
                      version="1.1"
                      id="L9"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      enableBackground="new 0 0 0 0"
                    >
                      <path
                        fill="#fff"
                        d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"
                      >
                        <animateTransform
                          attributeName="transform"
                          attributeType="XML"
                          type="rotate"
                          dur="1s"
                          from="0 50 50"
                          to="360 50 50"
                          repeatCount="indefinite"
                        />
                      </path>
                    </svg>
                  </button>
                  <p
                    style={{
                      display: Object.keys(props.state.errors).some((error) =>
                        ["validation", "conflict"].includes(error)
                      )
                        ? "block"
                        : "none",
                      textAlign: "center",
                      color: "red",
                      fontWeight: "700",
                      marginTop: "10px",
                    }}
                  >
                    *Invalid values found in highlighted fields above, please fix and try again.
                  </p>
                  <p
                    style={{
                      display: props.state.errors.serverError ? "block" : "none",
                      textAlign: "center",
                      color: "red",
                      fontWeight: "700",
                      marginTop: "10px",
                    }}
                  >
                    We are experiencing system issues at the moment, please try again later or give us a call. We
                    apologize for the inconvenience.
                  </p>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
}

const SectionTasks = (props) => {
  return (
    <div className="section wide img light gray apply">
      <div className="memberpod">
        <h2 className="heading-5 lightbg leftheading" style={{ marginBottom: "5px" }}>
          How can we help you?
        </h2>
        <p className="caption">Select all that apply.</p>

        <div className="boxSelect">
          <div style={{ flex: "0 0 50%", position: "relative", textAlign: "center" }}>
            <button
              className="selectButton"
              style={
                props.state.isTaskTransportationSelected
                  ? { backgroundColor: "#4F196F", color: "#ffffff" }
                  : { backgroundColor: "#ffffff", color: "#4F196F" }
              }
              onClick={(ev) => {
                ev.preventDefault();
                props.handleTaskSelection("transportation");
              }}
            >
              Transportation
              <img
                alt="unchecked"
                src={SelectUnchecked}
                style={{ display: props.state.isTaskTransportationSelected ? "none" : "block" }}
                className="selectUnchecked"
              />
              <img
                alt="checked"
                src={SelectChecked}
                style={{ display: props.state.isTaskTransportationSelected ? "block" : "none" }}
                className="selectChecked"
              />
            </button>
          </div>
          <div style={{ flex: "0 0 50%", position: "relative", textAlign: "center" }}>
            <button
              className="selectButton"
              style={
                props.state.isTaskFoodNutritionSelected
                  ? { backgroundColor: "#4F196F", color: "#ffffff" }
                  : { backgroundColor: "#ffffff", color: "#4F196F" }
              }
              onClick={(ev) => {
                ev.preventDefault();
                props.handleTaskSelection("food");
              }}
            >
              Food & Nutrition
              <img
                alt="unchecked"
                src={SelectUnchecked}
                style={{ display: props.state.isTaskFoodNutritionSelected ? "none" : "block" }}
                className="selectUnchecked"
              />
              <img
                alt="checked"
                src={SelectChecked}
                style={{ display: props.state.isTaskFoodNutritionSelected ? "block" : "none" }}
                className="selectChecked"
              />
            </button>
          </div>
        </div>
        <div className="boxSelect">
          <div style={{ flex: "0 0 50%", position: "relative", textAlign: "center" }}>
            <button
              className="selectButton"
              style={
                props.state.isTaskHealthcareSelected
                  ? { backgroundColor: "#4F196F", color: "#ffffff" }
                  : { backgroundColor: "#ffffff", color: "#4F196F" }
              }
              onClick={(ev) => {
                ev.preventDefault();
                props.handleTaskSelection("healthcare");
              }}
            >
              Healthcare
              <img
                alt="unchecked"
                src={SelectUnchecked}
                style={{ display: props.state.isTaskHealthcareSelected ? "none" : "block" }}
                className="selectUnchecked"
              />
              <img
                alt="checked"
                src={SelectChecked}
                style={{ display: props.state.isTaskHealthcareSelected ? "block" : "none" }}
                className="selectChecked"
              />
            </button>
          </div>
          <div style={{ flex: "0 0 50%", position: "relative", textAlign: "center" }}>
            <button
              className="selectButton"
              style={
                props.state.isTaskOtherSelected
                  ? { backgroundColor: "#4F196F", color: "#ffffff" }
                  : { backgroundColor: "#ffffff", color: "#4F196F" }
              }
              onClick={(ev) => {
                ev.preventDefault();
                props.handleTaskSelection("other");
              }}
            >
              Other
              <img
                alt="unchecked"
                src={SelectUnchecked}
                style={{ display: props.state.isTaskOtherSelected ? "none" : "block" }}
                className="selectUnchecked"
              />
              <img
                alt="checked"
                src={SelectChecked}
                style={{ display: props.state.isTaskOtherSelected ? "block" : "none" }}
                className="selectChecked"
              />
            </button>
          </div>
        </div>

        <div>
          <label htmlFor="reason" className="field-label" style={{ paddingBottom: "10px", paddingTop: "10px" }}>
            Anything else we should know?
          </label>
          <textarea
            value={props.state.reason}
            onChange={props.handleChange}
            className="text-field memberinput w-input"
            style={Object.assign(
              { marginBottom: "0px", height: "auto", width: "100%", padding: "10px 15px" },
              props.errorHandler("reason")
            )}
            rows="3"
            placeholder="Ex. I’d like to be more involved in my local community. Can you help me find some resources?"
            maxLength="512"
            name="reason"
            id="reason"
          />
        </div>
      </div>
    </div>
  );
};

const SectionPersonal = (props) => {
  return (
    <div className="section wide img light gray apply">
      <div className="memberpod">
        <h2 className="heading-5 lightbg leftheading" style={{ marginBottom: "5px" }}>
          Contact Information
        </h2>
        <p className="caption">Sign up to learn how DUOS can help.</p>
        <div className="w-container">
          <div className="contact-form-grid-2">
            <div className="collapseMobile">
              <label htmlFor="firstName" className="field-label left">
                First&nbsp;Name
              </label>
              <input
                value={props.state.firstName}
                onChange={props.handleChange}
                type="text"
                className="text-field memberinput w-input"
                style={props.errorHandler("firstName")}
                maxLength="256"
                name="firstName"
                placeholder=""
                id="firstName"
                required="required"
              />
            </div>
            <div className="collapseMobile">
              <label htmlFor="lastName" className="field-label">
                Last&nbsp;Name
              </label>
              <input
                value={props.state.lastName}
                onChange={props.handleChange}
                type="text"
                className="text-field memberinput w-input"
                style={props.errorHandler("lastName")}
                maxLength="256"
                name="lastName"
                placeholder=""
                id="lastName"
                required="required"
              />
            </div>
          </div>
          <div>
            <div>
              <label htmlFor="phone" className="field-label">
                Phone
              </label>
              <input
                value={props.state.phone}
                onChange={props.handleChange}
                type="tel"
                className="text-field memberinput w-input"
                style={Object.assign({ width: "100%", maxWidth: "500px" }, props.errorHandler("phone"))}
                maxLength="256"
                name="phone"
                placeholder="555-555-5555"
                id="phone"
                required="required"
                minLength="10"
              />
            </div>
            <div>
              <label htmlFor="email" className="field-label">
                Email (optional)
              </label>
              <input
                value={props.state.email}
                onChange={props.handleChange}
                type="email"
                className="text-field memberinput w-input"
                style={Object.assign({ width: "100%", maxWidth: "500px" }, props.errorHandler("email"))}
                maxLength="256"
                name="email"
                placeholder=""
                id="email"
              />
            </div>
          </div>
          <div>
            <div style={{ gridColumnStart: "span 2", gridColumnEnd: "span 2", whiteSpace: "nowrap" }}>
              <label htmlFor="birthMonth" className="field-label">
                Date of Birth
              </label>
              <input
                value={props.state.birthMonth}
                onChange={props.handleChange}
                type="text"
                className="text-field memberinput w-input"
                style={Object.assign(
                  { display: "inline-block", width: "75px", marginRight: "20px" },
                  props.errorHandler("birthMonth")
                )}
                maxLength="2"
                name="birthMonth"
                placeholder="MM"
                id="birthMonth"
                required="required"
                inputMode="numeric"
                pattern="\s*\d*\s*"
              />
              <input
                value={props.state.birthDay}
                onChange={props.handleChange}
                type="text"
                className="text-field memberinput w-input"
                style={Object.assign(
                  { display: "inline-block", width: "75px", marginRight: "20px" },
                  props.errorHandler("birthDay")
                )}
                maxLength="2"
                name="birthDay"
                placeholder="DD"
                id="birthDay"
                required="required"
                inputMode="numeric"
                pattern="\s*\d*\s*"
              />
              <input
                value={props.state.birthYear}
                onChange={props.handleChange}
                type="text"
                className="text-field memberinput w-input"
                style={Object.assign({ display: "inline-block", width: "125px" }, props.errorHandler("birthYear"))}
                maxLength="4"
                name="birthYear"
                placeholder="YYYY"
                id="birthYear"
                required="required"
                inputMode="numeric"
                pattern="\s*\d*\s*"
              />
            </div>
            <div style={{ gridColumnStart: "span 2", gridColumnEnd: "span 2" }}>
              <label htmlFor="zip" className="field-label">
                Zip Code
              </label>
              <input
                value={props.state.zip}
                onChange={props.handleChange}
                type="text"
                className="text-field memberinput w-input"
                style={Object.assign({ marginBottom: "0px", width: "200px" }, props.errorHandler("zip"))}
                maxLength="256"
                name="zip"
                placeholder=""
                id="zip"
                required="required"
                inputMode="numeric"
                pattern="\s*\d*\s*"
              />
              <label htmlFor="zip" className="caption">
                Duos is personalized based on location.
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const SectionInvite = (props) => {
  if (props.state.partner) {
    return null;
  } else {
    return (
      <div className="section wide img light gray apply">
        <div className="memberpod invite" style={{ backgroundColor: "#FFFFFF", paddingBottom: "30px" }}>
          <div>
            <h2 className="heading-5 lightbg leftheading sub">Invite Code</h2>
            <h6 className="subtitle">
              If you were sent a signup code through a third-party partner, you can enter it here.
            </h6>
            <div className="formfield half">
              <input
                value={props.state.inviteCode}
                onChange={props.handleChange}
                type="text"
                className="text-field memberinput w-input"
                style={Object.assign({ minWidth: "300px", width: "50%" }, props.errorHandler("inviteCode"))}
                maxLength="256"
                name="inviteCode"
                placeholder=""
                id="inviteCode"
                required=""
              />
              <p
                className="caption"
                style={{
                  display: props.state.errors["inviteCode"] ? "block" : "none",
                  color: "red",
                  position: "relative",
                  top: "-30px",
                }}
              >
                Your invite code is invalid. Please try again.
              </p>
            </div>
            <label id="contact-email" className="caption invite">
              Can’t find your invite code? Give us a call 855-212-9242.
            </label>
          </div>
        </div>
      </div>
    );
  }
};
